import React from "react";
import { CartProvider, ConfigProvider, NotificationProvider } from "@nusrif/contexts";
import { getTrackingId } from "@nusrif/services";

interface AppProvidersProps {
  children: React.ReactNode;
}

export const AppProviders: React.FC<AppProvidersProps> = ({ children }) => {
  React.useEffect(() => {
    getTrackingId(); // Ensures tracking ID is initialized on app load
  }, []);
  
  return (
    <ConfigProvider>
      <CartProvider>
        <NotificationProvider>
          {children}
        </NotificationProvider>
      </CartProvider>
    </ConfigProvider>
  );
};
